package util

import kotlinx.browser.document
import stats.js.Stats

object StatsManager {
    val stats = Stats().apply {
        if (!DebugManager.DEBUG_ENABLED) return@apply

        showPanel(0) // 0: fps, 1: ms, 2: mb, 3+: custom
        document.body!!.appendChild(domElement)
        with(domElement.style) {
            position = "fixed"
            top = "0px"
            left = "0px"
        }
    }

    fun begin() {
        if (DebugManager.DEBUG_ENABLED) stats.begin()
    }

    fun end() {
        if (DebugManager.DEBUG_ENABLED) stats.end()
    }
}